import { connect } from 'react-redux'
import { actions } from 'builder/modules/signIn'
import SignIn from 'builder/components/SignIn'
import { ConfigScopesEnum, selectors as appSelectors } from 'builder/modules/init'

const SignInView = props => {
  return <SignIn {...props} />
}

// ---
// Connect to data
// ---
const mapStateToProps = state => ({
  config: appSelectors.config(state, ConfigScopesEnum.signUp),
  signUpInfo: state.signUp.signUpInfo,
  ...state.signIn,
})

const mapDispatchToProps = {
  checkEmail: actions.checkEmailRequest,
  sendMagicLink: actions.sendMagicLinkRequest,
  sendPasswordLink: actions.sendPasswordLinkRequest,
  signUp: actions.signUpRequest,
  signIn: actions.signInRequest,
  checkMagicLink: actions.checkMagicLinkRequest,
}

export default connect(mapStateToProps, mapDispatchToProps)(SignInView)
